module.exports = __webpack_public_path__ + "static/media/larger_screen.051224b7.png";